module.exports = __webpack_public_path__ + "img/24c33d0.svg";